import type { Sensors } from "gql/api";
import type { EquipmentTableColumn } from "@/composables/equipment/equipmentTypes";

export const sensorTableColumns: EquipmentTableColumn<Sensors>[] = [
  {
    editable: true,
    field: "include_koc_timestamp",
    header: "Include KOC",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "only_koc_timestamp",
    header: "KOC Only",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "include_ecopetrol_timestamp",
    header: "Include Ecopetrol",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "only_ecopetrol_timestamp",
    header: "Ecopetrol Only",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "manufacturer",
    header: "Manufacturer",
    sortable: true,
    searchable: true
  },
  {
    editable: true,
    field: "part_number",
    header: "Part Number",
    sortable: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "length_inches",
    header: "Length (in)",
    isNumber: true,
    sortable: true,
    adminOnly: true,
    searchable: true
  },
  {
    editable: true,
    field: "outer_diameter_inches",
    header: "Outer Diameter (in)",
    isNumber: true,
    sortable: true,
    searchable: true,
    decimalPlaces: 6
  },
  {
    editable: true,
    field: "inner_diameter_inches",
    header: "Inner Diameter (in)",
    isNumber: true,
    sortable: true,
    searchable: true,
    decimalPlaces: 6,
    adminOnly: true
  },
  {
    editable: true,
    field: "neck_outer_diameter_inches",
    header: "Neck Outer Diameter (in)",
    isNumber: true,
    sortable: true,
    searchable: true,
    decimalPlaces: 6,
    adminOnly: true
  },
  {
    editable: true,
    field: "neck_inner_diameter_inches",
    header: "Neck Inner Diameter (in)",
    isNumber: true,
    sortable: true,
    searchable: true,
    decimalPlaces: 6,
    adminOnly: true
  },
  {
    editable: true,
    field: "weight_pounds",
    header: "Weight (lb)",
    isNumber: true,
    sortable: true,
    adminOnly: true,
    searchable: true
  },
  {
    editable: true,
    field: "model",
    header: "Model",
    sortable: true,
    searchable: true
  },
  {
    editable: true,
    field: "channels",
    header: "Channels",
    isNumber: true,
    sortable: true
  },
  {
    editable: true,
    field: "max_intake_temperature_fahrenheit",
    header: "Max Intake Temp (F)",
    isNumber: true,
    sortable: true,
    adminOnly: true,
    searchable: true
  },
  {
    editable: true,
    field: "max_intake_pressure_psi",
    header: "Max Intake Pressure (psi)",
    isNumber: true,
    sortable: true,
    adminOnly: true,
    searchable: true
  },
  {
    editable: true,
    field: "housing_material",
    header: "Housing Material",
    sortable: true,
    adminOnly: true,
    searchable: true
  }
];
